var map = {
	"./de.json": 880101,
	"./en.json": 561284,
	"./es.json": 256451,
	"./fr.json": 850770,
	"./it.json": 814036,
	"./ja.json": 229281,
	"./ko.json": 381002,
	"./pl.json": 370726,
	"./pt.json": 170405,
	"./ru.json": 912627,
	"./uk.json": 220014
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 298268;